module.exports = __webpack_public_path__ + "img/angry.491556cb.svg";